import React, { useEffect, useState } from 'react'
import Header from '../../common/header/Header'
import Card_Slider from '../home_page_components/card_slider/Card_Slider'
import Main_Slider from '../home_page_components/main_slider/Main_Slider'
import Home_Chat_Slider from '../home_page_components/home_chat_slider/Home_Chat_Slider'
import Home_By_Gemstone from '../home_page_components/home_by_gemstone/Home_By_Gemstone'
import Talk_To_Permium_Astrologer from '../home_page_components/talk_to_premium_astrologer/Talk_To_Permium_Astrologer'
import Home_Astro_Chat_Call from '../home_page_components/home_astro_chat_call/Home_Astro_Chat_Call'
import Home_Best_Selling_Products from '../home_page_components/home_best_selling_products/Home_Best_Selling_Products'
import Home_Sales_Banner from '../home_page_components/home_sales_banner/Home_Sales_Banner'
import Home_Exclusive_Design from '../home_page_components/home_exclusive_design/Home_Exclusive_Design'
import Home_Shop_By_Collection from '../home_page_components/home_shop by _collection/Home_Shop_By_Collection'
import Home_Satisfied_Customer from '../home_page_components/home_satisfied_customer/Home_Satisfied_Customer'
import Home_Faqs_Section from '../home_page_components/home_faq\'s_section/Home_Faqs_Section'
import Home_Letest_Post from '../home_page_components/home_letest_post/Home_Letest_Post'
import Home_Trusted_Customer from '../home_page_components/home_trusted_customer/Home_Trusted_Customer'
import Home_Private_Confidential from '../home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../../common/footer/Footer'
import { Visitors, send_newsletter, Get_Welcome_Note } from '../../../api/global/Global'
import Our_Celebrity from '../home_page_components/our_celebrity/Our_Celebrity'
import Loader from '../../../loader/Loader'
import { Helmet } from 'react-helmet'
import Home_Pandit_Chat_Call from '../home_page_components/home_pandit_chat_call/Home_Pandit_Chat_Call'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../config/Config'
import Custom_Banner from '../home_page_components/custom-banner/Custom_Banner'
import { toast } from 'react-toastify'
import { UAParser } from "ua-parser-js";
import { fetchSettingData } from '../../../redux/actions/settingAction'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHomeData } from '../../../redux/actions/homedataAction'

const Home = () => {
    const dispatch = useDispatch();

    const { homeData, isLoading } = useSelector(
        (state) => state?.homedata || []
    );
    const { settingData, tourData } = useSelector(
        (state) => state?.settingdata || []
    );

    const [isOpen, setIsOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [newsLetterdata, setNewsLetterData] = useState(null);

    useEffect(() => {
        dispatch(fetchHomeData());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchSettingData());
    }, [dispatch]);

    useEffect(() => {
        const get_newsletter_data = async () => {
            try {
                const response = await Get_Welcome_Note();

                if (response?.data?.status === 200) {
                    setNewsLetterData(response?.data?.data?.welcome_note);
                }
            } catch (error) {
                console.error("Failed to fetch welcome note", error);
            }
        };

        get_newsletter_data();
    }, []);

    useEffect(() => {
        const newsLetterPopUp = localStorage.getItem("newsLetterPopup");
        if (newsLetterPopUp) return
        setTimeout(() => {
            setIsOpen(true);
        }, 10000);
    }, []);

    const handleClose = () => {
        localStorage.setItem("newsLetterPopup", "true");
        setIsOpen(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // simple email validation
        if (!email) {
            setError("Please enter a valid email address");
            return;
        }
        setError("");

        // form data
        const formData = {
            email,
        };

        try {
            const response = await send_newsletter(formData)
            if (response?.data?.status == 200) {
                setIsOpen(false)
                toast.success(response?.data?.message)
                localStorage.setItem("newsLetterPopup", "true");
                setEmail("");
            }
            if (response?.data?.status == 409) {
                setError(response?.data?.message);
            }

        } catch (error) {
            console.error("newsletterError", error);
        }
    };

    async function collectData() {
        let deviceId = localStorage.getItem("device_id");
        if (!deviceId) {
            deviceId = crypto.randomUUID();
            localStorage.setItem("device_id", deviceId);
        }

        // public IP
        const ipRes = await fetch("https://api64.ipify.org?format=json");
        const { ip } = await ipRes.json();

        // browser + device
        const parser = new UAParser();
        const result = parser.getResult();
        const browser = result.browser.name + " " + result.browser.version;
        const device = result.device.type || "Desktop";
        const page = window.location.href;
        const referrer = document.referrer || "Direct";
        const data = { ip, deviceId, browser, device, page, referrer }
        return data
    }


    useEffect(() => {
        const handleSaveVisitors = async () => {
            try {
                const data = await collectData();
                const response = await Visitors(data)

            } catch (error) {
                console.error(error)
            }
        }
        handleSaveVisitors();
    }, [])

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>{settingData[0]?.meta_title}</title>
                <meta name="description" content={settingData[0]?.meta_desc} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}`} />
            </Helmet>
            <div>
                {
                    isLoading ? (
                        <Loader />
                    ) : (
                        <>
                            {/* <---------- Header section's -------------> */}
                            <Header />

                            {/* <!-- Cart sidebar Start --> */}
                            <Card_Slider />

                            {/* <!-- Hero Slider Start --> */}
                            <Main_Slider data={homeData} />

                            {/* <!-- Home_Chat_Slider section --> */}
                            <Home_Chat_Slider />

                            {/* <-------- Category section's ------> */}
                            {/* <Home_Category data={home_data} /> */}

                            {/* <!--  Home_By_Gemstone Start --> */}
                            <Home_By_Gemstone data={homeData} />

                            {/* <!-- Banner section --> */}
                            <Home_Sales_Banner data={homeData} />

                            {/* <!-- Home Best Selling Products --> */}
                            <Home_Best_Selling_Products data={homeData} />

                            {/* <!-- Banner section --> */}
                            <Talk_To_Permium_Astrologer data={homeData} />

                            {/* <!-- Home_Astro_Chat_Call section's --> */}
                            <Home_Astro_Chat_Call data={homeData} />

                            {/* <!-- Home_Pandit_Chat_Call section's --> */}
                            <Home_Pandit_Chat_Call data={homeData} />



                            {/* <!-- Banner section --> */}
                            <Custom_Banner tourData={tourData} />

                            {/* <!-- Home_Shop_By_Collection Start --> */}
                            <Home_Shop_By_Collection data={homeData} />

                            {/* <------- Our Ceebrity --------> */}
                            <Our_Celebrity data={homeData} />

                            {/* <!-- Exclusive Custom Designs Start --> */}
                            <Home_Exclusive_Design />

                            {/* <!-- Home_Satisfied_Customer section --> */}
                            <Home_Satisfied_Customer data={homeData} />
                            {/* // <!--  Day Of The Deal Start End --> */}

                            {/* <Home_Right_For_You_Banner /> */}
                            {/* <----- Home Why astrology ------------> */}
                            {/* <Home_Why_Astrology /> */}

                            {/* <!-- Faq section --> */}
                            <Home_Faqs_Section />
                            {/* <!-- Faq section End --> */}

                            {/* <!-------- Home_Letest_Post Section Start --> */}
                            <Home_Letest_Post data={homeData} />

                            {/* <!-- Trusted customer --> */}
                            <Home_Trusted_Customer />
                            {/* <!-- Trusted customer End --> */}

                            {/* <--------- Private & Confidential  ---------> */}
                            <Home_Private_Confidential />

                            {/* <---------- footer section's ------------> */}
                            <Footer />
                            {/* Welcome Note Model */}
                            {isOpen && newsLetterdata && (
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90">
                                    <div className="w-[90%] lg:w-[50%] rounded-lg shadow-lg relative">
                                        <button onClick={() => handleClose()} className="absolute top-2 right-2  text-gray-700 text-2xl">
                                            &times;
                                        </button>
                                        <div className='bg-white grid grid-cols-1 sm:grid-cols-2 h-full'>
                                            <img src={`${IMG_BASE_URL}${newsLetterdata[0]?.image}`} alt="Gemstones" className="aspect-[calc(4*3+1)/12] object-cover object-center w-full mx-auto" />
                                            <div className="p-6 lg:px-12 flex flex-col justify-center items-start text-left">
                                                <h1 className="text-xl font-bolder mb-4 uppercase"><span>{newsLetterdata[0]?.sub_title}</span> {newsLetterdata[0]?.title}</h1>
                                                <p className="text-sm text-gray-600 mb-3">
                                                    {newsLetterdata[0]?.description}
                                                </p>
                                                <form className='w-full' onSubmit={handleSubmit}>
                                                    <input type="email" name='newsletter_email' className='w-full text-sm p-2 px-4 border border-gray-200 text-[13px] mb-3 focus:outline-none focus:ring-1 focus:border-gray-200' placeholder='Enter your Email*' required
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)} />
                                                    {error && <p className="text-red-500 text-xs mb-2">{error}</p>}
                                                    <button type='submit' className='p-2 text-sm text-center bg-[#A32526] w-full text-white hover:bg-slate-500 mb-3'>SUBMIT</button>
                                                    {/* <div className='flex justify-center gap-2 items-center'>
                                                        <input type="checkbox" />
                                                        <span className='text-[12px]'>Subscribe for exclusive offers from Omens</span>
                                                    </div> */}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )
                }

            </div >
        </>
    )
}

export default Home